module.exports = __webpack_public_path__ + "static/media/close_drawer.248a8810.png";